import { ModeloAeronave } from './../../model/aeronave/modeloAeronave';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { GenericService } from '../generics/generic.service';
import { GenericDuploService } from '../generics/genericDuplo.service';
import { AeronaveComposicao } from 'src/app/model/aeronave/aeronaveComposicao';
import { AutoRegisterService } from '../generics/servicesRegistry ';
import { ModeloAeronaveComposicao } from 'src/app/model/aeronave/modeloAeronaveComposicao';

@Injectable({
  providedIn: 'root'
})

@AutoRegisterService()
export class ModeloAeronaveService extends GenericDuploService<ModeloAeronave, ModeloAeronaveComposicao>{
  constructor(http: HttpClient) { 
    super(http);
    super.initResource("modeloaeronave")
  }
}
